const fixAlt = (el) => {
    if (!el.hasAttribute('alt')) el.setAttribute('alt', '');
};

const fixUpCart = () => {
    const el = document.querySelector('#upCart');
    if (!el) return;
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'UpCart')
}

document.querySelectorAll('img').forEach(fixAlt);
fixUpCart();

new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            if (node.tagName === 'IMG') fixAlt(node);
            node.querySelectorAll('img').forEach(fixAlt);
        });
    });
}).observe(document.body, { childList: true, subtree: true });